import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  Spinner,
} from "reactstrap";

import { UserApis } from "../../apis/UserApi";
import { useTranslation } from "react-i18next";

const ViewUser = () => {

  const { id } = useParams();

  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const { t, i18n } = useTranslation();

  const isRTL = i18n.language === "ar";

  // ✅ Set global direction properly
  useEffect(() => {

    document.documentElement.dir = isRTL ? "rtl" : "ltr";
    document.documentElement.lang = i18n.language;

  }, [isRTL, i18n.language]);


  useEffect(() => {

    if (!id) return;

    setLoading(true);

    UserApis.getUserById(id)
      .then((res) => {

        setUser(res.data?.data);
        setLoading(false);

      })
      .catch(() => {

        setError(t("Failed to load user details."));
        setLoading(false);

      });

  }, [id, t]);


  // ✅ Loading
  if (loading) {

    return (
      <Container className="text-center mt-5">
        <Spinner color="primary" />
        <p>{t("Loading user details...")}</p>
      </Container>
    );

  }


  // ✅ Error
  if (error) {

    return (
      <Container className="text-center mt-5">
        <p className="text-danger">{error}</p>
      </Container>
    );

  }


  // ✅ No user
  if (!user) {

    return (
      <Container className="text-center mt-5">
        <p>{t("No user found.")}</p>
      </Container>
    );

  }


  // ✅ Main UI
  return (

    <Container className="mt-5">

      <Row>
     
        <Col md={{ size: 10, offset: 1 }}>
          <br /><br />
          <Card>

            <CardBody className={isRTL ? "text-end" : "text-start"}>

              <h3 className="mb-3">

                {t("User Details")}

              </h3>

              <hr />


              <p>

                <strong>{t("User ID")}:</strong>{" "}

                <span dir="ltr">{user.id}</span>

              </p>


              <p>

                <strong>{t("Full Name")}:</strong>{" "}

                <span dir={isRTL ? "rtl" : "ltr"}>

                  {[user.firstname, user.lastname]
                    .filter(Boolean)
                    .join(" ")}

                </span>

              </p>


              <p>

                <strong>{t("Email")}:</strong>{" "}

                <span dir="ltr">

                  {user.email || "-"}

                </span>

              </p>


              <p>

                <strong>{t("Phone")}:</strong>{" "}

                <span dir="ltr">

                  {user.phone_number
                    ? `+${user.country_phone_code} ${user.phone_number}`
                    : "-"}

                </span>

              </p>


              <p>

                <strong>{t("Gender")}:</strong>{" "}

                {user.gender || "-"}

              </p>


              <p>

                <strong>{t("Date of Birth")}:</strong>{" "}

                <span dir="ltr">

                  {user.date_of_birth || "-"}

                </span>

              </p>


              <p>

                <strong>{t("Specialities")}:</strong>{" "}

                {user.specialities || "-"}

              </p>


              <p>

                <strong>{t("Wallet Balance")}:</strong>{" "}

                <span dir="ltr">

                  ₹{user.wallet_balance ?? 0}

                </span>

              </p>


              <p>

                <strong>{t("Status")}:</strong>{" "}

                {user.status === 1
                  ? t("Active")
                  : t("Inactive")}

              </p>


              <p>

                <strong>{t("Role")}:</strong>{" "}

                {user.role_name || "-"}

              </p>


              <p>

                <strong>{t("Address")}:</strong>{" "}

                {user.address || "-"}

              </p>


            </CardBody>

          </Card>

        </Col>

      </Row>

    </Container>

  );

};

export default ViewUser;